import type { Field as FieldPrimitive } from "@base-ui/react/field";
import { cva, type VariantProps } from "cva";
import { formatArktypeValidationMessage } from "#ui-atoms/lib/formatters";
import { cn } from "#ui-atoms/lib/utils";

const baseFieldErrorVariants = cva({
  base: "text-[0.8rem] font-medium text-destructive",
  variants: {
    variant: {
      default: undefined,
      card: "text-primary",
    },
    size: {
      default: undefined,
      sm: "text-sm",
      md: "text-base",
      lg: "text-lg",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface BaseFieldErrorProps extends FieldPrimitive.Error.Props {
  variant?: VariantProps<typeof baseFieldErrorVariants>["variant"];
  size?: VariantProps<typeof baseFieldErrorVariants>["size"];
}

export function BaseFieldError({
  className,
  variant,
  size,
  children,
  ...props
}: BaseFieldErrorProps) {
  const displayContent = children
    ? typeof children === "string"
      ? formatArktypeValidationMessage(children)
      : children
    : null;

  return (
    <div
      className={cn(
        "min-h-5 w-full min-w-0 break-words",
        baseFieldErrorVariants({ variant, size, className }),
      )}
      data-slot="field-error"
      {...props}
    >
      {displayContent}
    </div>
  );
}
